<template>
  <StaffLayout section="Respond Scenarios" showHeader>
    <div v-if="isLoading"><Loading /></div>
    <div v-else>
      <div v-if="scenarios && scenarios.length > 0">
        <AddButton @click="addClick">Add Respond Scenario</AddButton>
        <div
          class="px-4 py-2 my-2 bg-gray-100 border-t cursor-pointer hover:bg-blue-200"
          v-for="scenario in scenarios"
          :key="scenario.responseTypeId"
          @click="editClick(scenario)"
        >
          {{ scenario.name }}
        </div>
      </div>
      <div v-else class="mb-2">
        <span>-- No Respond Scenarios found --</span>
      </div>
      <div class="mt-1">
        <AddButton @click="addClick">Add Respond Scenario</AddButton>
      </div>
    </div>
    <EditPopup
      entity-name="Scenario"
      :is-visible="isPopupVisible"
      :is-edit-mode="isEditing"
      :save-error="saveError"
      :delete-enabled="true"
      @close="isPopupVisible = false"
      @save="saveClick"
      @delete="deleteClick"
    >
      <BaseInput label="Scenario Name" v-model="name" type="text" :error="errors.name" />
      <BaseInput
        label="System Name"
        v-model="systemName"
        type="text"
        :error="errors.systemName"
      />
    </EditPopup>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useRespondStore } from "../../store/respondStore";
import {
  ResponseTypeDTO,
  SaveResponseTypeRequest,
} from "../../store/generatedFetchClient";

import { useField, useForm } from "vee-validate";
import * as yup from "yup";

const respondStore = useRespondStore();

let scenarios = computed(() => respondStore.responseTypes);
const isLoading = ref(false);

onMounted(loadData);
async function loadData() {
  isLoading.value = true;
  await respondStore.getResponseTypes();
  isLoading.value = false;
}

// Popup stuff
const isPopupVisible = ref(false);
const isEditing = ref(false);
const saveError = ref("");

const { handleSubmit, errors } = useForm({
  validationSchema: yup.object({
    name: yup.string().required().max(50).label("Name"),
    systemName: yup.string().required().max(50).label("System Name"),
  }),
  initialValues: {
    name: "",
    systemName: "",
  },
});

var responseTypeId = 0;
const { value: name } = useField<string>("name");
const { value: systemName } = useField<string>("systemName");

let saveClick = handleSubmit(onValidSubmit, onInvalidSubmit);

async function onValidSubmit() {
  console.log(`Saving Scenario '${name.value}'`);

  saveError.value = await respondStore.saveResponseType({
    responseTypeId: responseTypeId,
    name: name.value,
    systemName: systemName.value,
  } as SaveResponseTypeRequest);

  if (!saveError.value) {
    isPopupVisible.value = false;
    await respondStore.getResponseTypes(true);
  }
}

function onInvalidSubmit(ctx: any) {
  saveError.value = "One or more invalid form inputs.";
  console.log("error trying to submit form", ctx);
}

async function addClick() {
  responseTypeId = 0;
  name.value = "";
  systemName.value = "";

  isEditing.value = false;
  saveError.value = "";
  isPopupVisible.value = true;
}

function editClick(scenario: ResponseTypeDTO) {
  responseTypeId = scenario.responseTypeId;
  name.value = scenario.name;
  systemName.value = scenario.systemName;

  isEditing.value = true;
  saveError.value = "";
  isPopupVisible.value = true;
}

async function deleteClick() {
  saveError.value = await respondStore.deleteResponseType(responseTypeId);

  if (!saveError.value) {
    await respondStore.getResponseTypes(true);
    isPopupVisible.value = false;
  }
}
</script>
